export const DefaultBoxFillColor = 0x005cb2;
export const DefaultCheckerColor = 0xffffff;